import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout, ConfigProvider } from 'antd';
import idID from 'antd/locale/id_ID';
import dayjs from 'dayjs';
import 'dayjs/locale/id'; // Import Indonesia locale untuk dayjs

// Setup dayjs dengan locale Indonesia
dayjs.locale('id');

import MainContext from 'contexts';

import { Sidebar } from 'components/sidebar';
import AuthenticatedGuardRoute from 'components/guard/authenticated';
import NotAuthenticatedGuardRoute from 'components/guard/notAuthenticated';

import {
  AboutUs,
  AboutUsCreateEdit,
  Admin,
  AdminActivities,
  AdminCreateEdit,
  Banner,
  BannerCreateEdit,
  BlackoutDate,
  BlackoutDateCreateEdit,
  Brand,
  BrandCreateEdit,
  Category,
  CategoryCreateEdit,
  CategorySection,
  CategorySectionCreateEdit,
  // CheckingInspection,
  // CheckingInspectionDetail,
  Collection,
  CollectionCreateEdit,
  Courier,
  CourierCreateEdit,
  Customer,
  CustomerDetail,
  CustomerWallet,
  // Disbursement,
  // DisbursementDetail,
  Discount,
  DiscountCreateEdit,
  ErrorPage,
  // ExchangeRent,
  // ExchangeRentDetail,
  Fee,
  // Flashsale,
  // FlashsaleCreateEdit,
  Home,
  InboundOrderDetails,
  InboundOrders,
  Inspection,
  InspectionDetail,
  Media,
  Location,
  Login,
  Order,
  OrderDetail,
  OutboundOrderDetails,
  OutboundOrders,
  // Penalty,
  // PenaltyDetail,
  PickUpPoint,
  PickUpPointForm,
  Product,
  ProductCreateEdit,
  ProductSection,
  ProductSectionCreateEdit,
  ProfileChangePassword,
  Promo,
  PromoCreateEdit,
  PromoSection,
  PromoSectionCreateEdit,
  // RentDuration,
  // RentDurationsCreateEdit,
  // RentOrders,
  // RentReturn,
  // RentReturnDetail,
  // RentStock,
  ResellerActive,
  ResellerActiveDetail,
  ResellerCashback,
  ResellerOrders,
  ResellerPage,
  ResellerPageCreateEdit,
  ResellerStatus,
  ResellerStatusDetail,
  ResellerWithdrawal,
  ResellersCashbackCreateEdit,
  // Return,
  // ReturnDetail,
  RiskManagement,
  Role,
  RoleCreateEdit,
  SearchSuggestion,
  Shipment,
  ShipmentDetail,
  Stock,
  Terms,
  TermsCreateEdit,
  ValueCreateEdit,
  Warehouse,
  WarehouseCreateEdit,
  OrderPackage,
} from 'pages';

import 'antd/dist/antd.css';
import './App.scss';
// import { OrderExchange } from 'pages/dashboard/order-exchange';
// import { OrderExchangeDetail } from 'pages/dashboard/order-exchange/detail';
// import { OrderRefund } from 'pages/dashboard/order-refund';
// import { OrderRefundDetail } from 'pages/dashboard/order-refund/detail';

const routes = [
  { component: AboutUs, path: '/about_us_pages' },
  { component: AboutUsCreateEdit, path: '/about_us_pages/:page' },
  { component: Admin, path: '/admins' },
  { component: AdminActivities, path: '/activities' },
  { component: AdminCreateEdit, path: '/admins/:page' },
  { component: AdminCreateEdit, path: '/profile' },
  { component: Banner, path: '/banners' },
  { component: BannerCreateEdit, path: '/banners/:page' },
  { component: BlackoutDate, path: '/blackout_dates' },
  { component: BlackoutDateCreateEdit, path: '/blackout_dates/:page' },
  { component: Brand, path: '/brands' },
  { component: BrandCreateEdit, path: '/brands/:page' },
  { component: Category, path: '/categories' },
  { component: CategoryCreateEdit, path: '/categories/:page' },
  { component: CategorySection, path: '/category-sections' },
  { component: CategorySectionCreateEdit, path: '/category-sections/:page' },
  // { component: CheckingInspection, path: '/review_inspections' },
  // { component: CheckingInspectionDetail, path: '/review_inspections/detail' },
  { component: Collection, path: '/collections' },
  { component: CollectionCreateEdit, path: '/collections/:page' },
  { component: Courier, path: '/couriers' },
  { component: CourierCreateEdit, path: '/couriers/:page' },
  { component: Customer, path: '/customers' },
  { component: CustomerDetail, path: '/customers/detail' },
  { component: CustomerWallet, path: '/customer-wallet' },
  // { component: Disbursement, path: '/disbursements' },
  // { component: DisbursementDetail, path: '/disbursements/detail' },
  { component: Discount, path: '/discounts' },
  { component: DiscountCreateEdit, path: '/discounts/:page' },
  { component: ErrorPage, path: '/error' },
  // { component: ExchangeRent, path: '/rent_exchange' },
  // { component: ExchangeRentDetail, path: '/rent_exchange/detail' },
  { component: Fee, path: '/fee' },
  // { component: Flashsale, path: '/flash_sales' },
  // { component: FlashsaleCreateEdit, path: '/flash_sales/:page' },
  { component: Home, path: '/' },
  { component: Location, path: '/locations' },
  {
    component: InboundOrderDetails,
    path: '/pickup_points/inbound-order/detail',
  },
  { component: InboundOrders, path: '/pickup_points/inbound-order' },
  { component: Inspection, path: '/inspections' },
  { component: InspectionDetail, path: '/inspections/detail' },
  { component: Media, path: '/media_products' },
  { component: Order, path: '/orders' },
  { component: OrderDetail, path: '/orders/detail' },
  { component: OrderPackage, path: '/orders/package' },
  {
    component: OutboundOrderDetails,
    path: '/pickup_points/outbound-order/detail',
  },
  // { component: OrderRefund, path: '/order_refund' },
  // { component: OrderRefundDetail, path: '/order_refund/detail' },
  { component: OutboundOrders, path: '/pickup_points/outbound-order' },
  // { component: OrderExchange, path: '/order_exchange' },
  // { component: OrderExchangeDetail, path: '/order_exchange/detail' },
  // { component: Penalty, path: '/penalties' },
  // { component: PenaltyDetail, path: '/penalties/detail' },
  { component: PickUpPoint, path: '/pickup_points/location' },
  {
    component: PickUpPointForm,
    path: '/pickup_points/location/create-edit',
  },
  { component: Product, path: '/products' },
  // { component: Product, path: '/rent_products' },
  { component: ProductCreateEdit, path: '/products/:page' },
  { component: ProductSection, path: '/product-section' },
  { component: ProductSectionCreateEdit, path: '/product-section/:page' },
  { component: ProfileChangePassword, path: '/profile/change-password' },
  { component: Promo, path: '/promos' },
  { component: PromoCreateEdit, path: '/promos/:page' },
  { component: PromoSection, path: '/promo-section' },
  { component: PromoSectionCreateEdit, path: '/promo-section/:page' },
  // { component: RentDuration, path: '/rent_durations' },
  // { component: RentDurationsCreateEdit, path: '/rent_durations/:page' },
  // { component: RentOrders, path: '/rent_orders' },
  // { component: RentReturn, path: '/rent_returns' },
  // { component: RentReturnDetail, path: '/rent_returns/detail' },
  // { component: RentStock, path: '/rent-stocks' },
  { component: ResellerActive, path: '/resellers_active' },
  { component: ResellerActiveDetail, path: '/resellers_active/detail' },
  { component: ResellerCashback, path: '/resellers_cashback' },
  { component: ResellerOrders, path: '/resellers_orders' },
  { component: ResellerPage, path: '/resellers_page' },
  { component: ResellerPageCreateEdit, path: '/resellers_page/:page' },
  { component: ResellerStatus, path: '/resellers_status' },
  { component: ResellerStatusDetail, path: '/resellers_status/detail' },
  { component: ResellerWithdrawal, path: '/resellers_withdrawal' },
  {
    component: ResellersCashbackCreateEdit,
    path: '/resellers_cashback/create',
  },
  // { component: Return, path: '/returns' },
  // { component: ReturnDetail, path: '/returns/detail' },
  { component: RiskManagement, path: '/risk_managements' },
  { component: Role, path: '/roles' },
  { component: RoleCreateEdit, path: '/roles/:page' },
  { component: SearchSuggestion, path: '/search_suggestions' },
  { component: Shipment, path: '/shipments' },
  { component: ShipmentDetail, path: '/shipments/detail' },
  { component: Stock, path: '/stocks' },
  { component: Terms, path: '/terms_and_conditions' },
  { component: TermsCreateEdit, path: '/terms_and_conditions/:page' },
  { component: ValueCreateEdit, path: '/about_us_pages/value/:page' },
  { component: Warehouse, path: '/warehouses' },
  { component: WarehouseCreateEdit, path: '/warehouses/:page' },
];

// Wrapper component for dashboard layout with nested routes
function DashboardLayout() {
  return (
    <Layout className="pd-cms">
      <Sidebar />
      <Routes>
        {routes.map((route, idx) => (
          <Route
            key={idx}
            path={route.path}
            element={<route.component />}
          />
        ))}
        <Route path="" element={<ErrorPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <ConfigProvider theme={{
      token: {
        fontFamily: "'Roboto', sans-serif",
      },
      components : {
        Button : {
          colorPrimary : '#3f4c9f',
        }
      }
    }} locale={idID}>
      <Router>
        <MainContext>
          <Routes>
            <Route
              path="/login"
              element={
                <NotAuthenticatedGuardRoute>
                  <Login />
                </NotAuthenticatedGuardRoute>
              }
            />
            <Route
              path="/*"
              element={
                <AuthenticatedGuardRoute>
                  <DashboardLayout />
                </AuthenticatedGuardRoute>
              }
            />
          </Routes>
        </MainContext>
      </Router>
    </ConfigProvider>
  );
}

export default App;
